import IllustratedInfoCard, {
  AppearanceProps,
  Title,
  Paragraph,
} from '../../../components/cards/IllustratedInfoCard'
import { LearnMoreLink } from '../shared'

import { image as onboardingHeaderImage } from '../../hostOnboarding/onboarding/Header'

type HostInfoCardProps = AppearanceProps & {
  marketCode: string
  marketName: string
}

const HostInfoCard = ({
  marketCode,
  marketName,
  ...props
}: HostInfoCardProps) => {
  const { inverseColors } = props

  const image = {
    medium: onboardingHeaderImage.medium.url,
    large: onboardingHeaderImage.large.url,
  }

  const learnMoreUrl = `/list-with-us?market=${marketCode}`

  return (
    <IllustratedInfoCard image={image} alt="Become a Riparide Host" {...props}>
      <Title>Become a Riparide Host</Title>
      <Paragraph>
        List your property on Riparide now and be one of the original properties
        when we launch in {marketName}.
      </Paragraph>
      <LearnMoreLink to={learnMoreUrl} inverse={!inverseColors}>
        Learn more
      </LearnMoreLink>
    </IllustratedInfoCard>
  )
}

export default HostInfoCard
